import { IId } from '../../shared/models/id';
import { ISelectable } from '../../shared/models/selectable';

export const CATEGORY: ISelectable[] = [
  { id: 1, title: 'School Life' },
  { id: 2, title: 'College Questions' },
  { id: 3, title: 'After School & Summer' },
  { id: 4, title: 'RoundPier Stuff' },
  { id: 5, title: 'Research' },
  { id: 6, title: 'Entrepreneurship' },
  { id: 7, title: 'Politics' },
  { id: 8, title: 'Economics & Finance' },
  { id: 9, title: 'STEM' }
];

export const AGE_GROUP: ISelectable[] = [
  { id: 1, title: '3-6 years' },
  { id: 2, title: '7-9 years' },
  { id: 3, title: '10-13 years' },
  { id: 4, title: '14-17 years' },
  { id: 5, title: 'any' }
];

export const ACCESS: ISelectable[] = [
  { id: 1, title: 'Open for all' },
  { id: 2, title: 'Open to RoundPier members' }
];

export function getSelectable(array: ISelectable[], value: IId) {
  if (!value) return null; // #Return#
  return array.find(({ id }) => id === +value.id);
}
